import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/index';

function AsyncButtonSendMail(props) {
  const {
    loading,
    onClick,
    className,
    children,
    spinner,
    disabled,
    id,
    onKeyDown,
  } = props;
  const checked = true;
  const buttonStyle = {
    display: 'flex',
    alignItems: 'center',
  };
  return (
    <div className="checkbox-container-success">
      <button
        disabled={loading || disabled}
        onClick={onClick}
        className={className}
        id={id}
        onKeyDown={onKeyDown}
        style={buttonStyle}
      >
        {
          spinner &&
          <Icon name="fa-spinner fa-spin" style={{ marginRight: 5 }} />
        }
        {children}
        {
          disabled &&
          <div className="d-flex">
            <input disabled={checked} type="checkbox" defaultChecked={checked} />
            <span className="checkmark-success"></span>
          </div>
        }
      </button>
    </div>
  );
}

AsyncButtonSendMail.propTypes = {
  spinner: PropTypes.bool,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.any,
  onKeyDown: PropTypes.any,
};

export default AsyncButtonSendMail;



// WEBPACK FOOTER //
// ./app/components/AsyncButtonSendMail/index.js